import { Box, BoxProps, ModBox, Spacer, SpacerNew, TextNew } from '@jfs/ui-new'
import { useState } from 'react'
import { Switch } from 'react-native'
import { ExpandAddView } from '../../components/ExpandAddView'
import { useStores } from '../../data/store'
import { ApprovalTypes } from '../../utils/constants'
import { MasterApprovals } from '../EntityApprovals/MasterApprovals'
import { EssAuditTrials } from '../EssAuditTrials'

const EmsApprovals = () => {
  const {
    crdrAdjApproval,
    riskConTxnApproval,
    riskConMidApproval,
    payoutCmsApproval,
    hasAuditAccess,
    isAccessConfigPriviledged,
  } = useStores((store) => ({
    crdrAdjApproval: store.user.getAccessConfig(['ess', 'crdr_adjustment', 'approve', 'isAccessible']),
    riskConTxnApproval: store.user.getAccessConfig(['ess', 'risk_config', 'approve', 'isAccessible']),
    riskConMidApproval: store.user.getAccessConfig(['ess', 'risk_config', 'approve', 'isAccessible']),
    payoutCmsApproval: store.user.getAccessConfig(['ess', 'payout_cms_update', 'approve', 'isAccessible']),
    hasAuditAccess: store.user.getAccessConfig(['sys_control_config', 'audit', 'approval_audit_fetch', 'isAccessible']),
    isAccessConfigPriviledged: store.user.getAccessConfig([
      'sys_control_config',
      'audit',
      'approval_audit_privileged',
      'isAccessible',
    ]),
  }))
  const [isUserApprover, setUserApprover] = useState(false)

  const handleToggle = (val: boolean) => {
    setUserApprover(val)
  }

  return (
    <Box>
      <Box {...styles.container}>
        <ModBox show={crdrAdjApproval}>
          <ExpandAddView title={'Credit Debit Adjustment Approvals'}>
            <MasterApprovals
              type={ApprovalTypes.CREDIT_ADJUSTMENT}
              title={'Credit Debit Adjustment Approvals'} //need this to show export button check
              hideTitle={true} // to hide repetive title
            />
          </ExpandAddView>
        </ModBox>
        {/*<Spacer direction="vertical" size={24} />
        <ModBox {...styles.container} show={riskConTxnApproval}>
          <ExpandAddView title={'Risk Controls - Transactions - Approvals'}>
            <MasterApprovals
              type={ApprovalTypes.RISK_CONFIG_TXNS}
              showCurrentData={false}
              showUpdatedData={false}
              title={'Risk Controls - Transactions - Approvals'} //need this to show export button check
              hideTitle={true}
            />
          </ExpandAddView>
  </ModBox>
        <Spacer direction="vertical" size={24} />
        <ModBox {...styles.container} show={riskConMidApproval}>
          <ExpandAddView title={'Risk Controls - MID - Approvals'}>
            <MasterApprovals
              type={ApprovalTypes.RISK_CONFIG_MID}
              showCurrentData={false}
              showUpdatedData={false}
              title={'Risk Controls - MID - Approvals'} //need this to show export button check
              hideTitle={true} // to hide repetive title
            />
          </ExpandAddView>
      </ModBox>*/}
        <Spacer direction="vertical" size={24} />
        <ModBox {...styles.container} show={payoutCmsApproval}>
          <ExpandAddView title={'Payout CMS - Approvals'}>
            <MasterApprovals
              type={ApprovalTypes.PAYOUT_CMS}
              showCurrentData={false}
              showUpdatedData={true}
              title={'Payout CMS - Approvals'} //need this to show export button check
              hideTitle={true}
            />
          </ExpandAddView>
        </ModBox>
        <Spacer direction="vertical" size={24} />
        <ModBox
          show={!isAccessConfigPriviledged && hasAuditAccess}
          p={40}
          align={'center'}
          justify={'flex-end'}
          flexDirection={'row'}>
          <TextNew title={'User'} fontFamily={'jiotype-medium'} fontSize={16} color={'BLACK_21'} />
          <SpacerNew direction={'horizontal'} size={12} />
          <Switch onValueChange={handleToggle} value={isUserApprover} />
          <SpacerNew direction={'horizontal'} size={12} />
          <TextNew title={'Approver'} fontFamily={'jiotype-medium'} fontSize={16} color={'BLACK_21'} />
        </ModBox>
        <Spacer direction="vertical" size={24} />
        <ModBox {...styles.container} show={hasAuditAccess}>
          <ExpandAddView title={'Credit Debit Adjustment Approvals - Audit Trail'}>
            <EssAuditTrials type={ApprovalTypes.CRDR_ADJUSTMENT_AUD_TRIAL} isApprover={isUserApprover} />
          </ExpandAddView>
        </ModBox>
        {/*<Spacer direction="vertical" size={24} />
        <ModBox {...styles.container} show={hasAuditAccess}>
          <ExpandAddView title={'Risk Controls - Transactions - Audit Trail'}>
            <EssAuditTrials type={ApprovalTypes.RISK_CONFIG_TXNS_AUD_TRIAL} isApprover={isUserApprover} />
          </ExpandAddView>
  </ModBox>
        <Spacer direction="vertical" size={24} />
        <ModBox {...styles.container} show={hasAuditAccess}>
          <ExpandAddView title={'Risk Controls - MID - Audit Trail'}>
            <EssAuditTrials type={ApprovalTypes.RISK_CONFIG_MID_AUD_TRIAL} isApprover={isUserApprover} />
          </ExpandAddView>
        </ModBox>*/}
        <Spacer direction="vertical" size={24} />
        <ModBox {...styles.container} show={hasAuditAccess}>
          <ExpandAddView title={'Payout CMS - Audit Trail'}>
            <EssAuditTrials type={ApprovalTypes.PAYOUT_CMS_AUD_TRIAL} isApprover={isUserApprover} />
          </ExpandAddView>
        </ModBox>
      </Box>
    </Box >
  )
}

export default EmsApprovals

const shadow = {
  shadowColor: '#000',
  shadowOffset: {
    width: 0,
    height: 1,
  },
  shadowOpacity: 0.22,
  shadowRadius: 2.22,
  elevation: 3,
}

const styles = {
  container: {
    ...shadow,
  } as BoxProps,
}
